import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ParameterType } from 'src/app/interfaces/parameter';
import { PainelService } from 'src/app/services/painel.service';
import { ParametersService } from 'src/app/services/parameters.service';
import { TotemPainelService } from 'src/app/services/totem-painel.service';
import { PainelType } from 'src/app/settings/interfaces/painel';
import { TotemType } from 'src/app/settings/interfaces/totem';
import { TotemPainelType } from 'src/app/settings/interfaces/totemPainel';

@Component({
  selector: 'app-add-totem',
  templateUrl: './add-totem.component.html',
  styleUrls: ['./add-totem.component.scss']
})
export class AddTotemComponent implements OnInit {

  tabGroupIndex: number = 0
	mode: string = "all"
	totemPainelMode: string = "all"
	totemPaineis: Array<TotemPainelType> = []
	totemPainel: TotemPainelType = {}
	totems: Array<TotemType> = []
	totem: TotemType = {}
	tempPainelTotem: Array<TotemPainelType> = []
	paineis: Array<PainelType> = []
	showSpinner: boolean = false
	showPainelWarning: boolean = false
	showMultiplePainelWarning: boolean = false
	public formTotem!: FormGroup;
	public formTotemPainel!: FormGroup


	public parameters: Array<ParameterType> = []
	public params: Array<string> = [
		"PRIORITY",
		"TOTEM_CALENDAR",
		"TOTEM_PRINTER"
	]
	public formSettings: FormGroup
	public parametersResponse: Array<ParameterType> = []


	public columns = [
		{
			columnDef: 'id',
			header: 'ID',
			cell: (element: TotemType) => `${element.id}`,
		},
		{
			columnDef: 'nome',
			header: 'Nome',
			cell: (element: TotemType) => `${element.nome}`,
		},
		{
			columnDef: 'prefixo',
			header: 'Prefixo',
			cell: (element: TotemType) => `${element.prefixo}`,
		}, 
		{
			columnDef: 'edit'
		}
	];
	public displayedColumns = this.columns.map(c => c.columnDef)

	public columnsPainel = [
		{
			columnDef: 'painelnome',
			header: 'Painel',
			cell: (element: TotemPainelType) => `${element.painelnome}`,
		},
		{
			columnDef: 'edit'
		}
	];
	public displayedColumnsPainel = this.columnsPainel.map(c => c.columnDef)

	constructor(
		private totemService: TotemPainelService,
		private formBuilder: FormBuilder,
		private parameterService: ParametersService,
		private route: ActivatedRoute,
		private painelService: PainelService
	) {
		this.formSettings = this.formBuilder.group({})
		this.createTotemSettingsForm()
		this.parametersResponse = this.route.snapshot.data['params']
		this.parameterService.getVarSys("USAR_LOCAL").subscribe(
			(varSys) => {
				let aux = varSys[0]
				aux.chave = aux.param
				aux.valor = aux.value
				this.parametersResponse.push(aux)
			}
		)
	}

	ngOnInit(): void {

		setTimeout(() => {
			this.parametersResponse.forEach((item: ParameterType) => {
				const control = this.formSettings.get(item.chave!);
				if (control) {
					control.setValue(item.valor);
				}
			});
	
		}, 1000);

		this.loadTotems()
		this.loadPaineis()
	}

	createTotemSettingsForm() {
		this.params.forEach(element => {
			this.formSettings.addControl(element, new FormControl())
		});
	}

	
	submitTotemSettingsForm() {
		this.showSpinner = true
		this.parameterService.updateParams(this.formSettings.value)
		setTimeout(() => {
			this.showSpinner = false
			window.location.reload()
		}, 2000);
	}

	testPrint() {
		fetch(`http://localhost:8080/imprimir/teste`)
	}

	loadTotems() {
		this.totemService.getTotems().subscribe(
			(resp) => {
				this.totems = resp
			}
		)
	}

	loadPaineis() {
		this.painelService.getPaineis().subscribe(
			(resp) => {
				this.paineis = resp
			}
		)
	}

	loadTotemPaineis(id: number) {
		this.totemService.getTotemPaineis(id).subscribe(
			(resp) => {
				this.totemPaineis = resp
			}
		)
	}

	newForm(i?: number) {
		this.tempPainelTotem = []
		this.totemPaineis = []
		this.showPainelWarning = false
		this.showMultiplePainelWarning = false
		this.createForm()
		if (i !== undefined && i !== null) {
			this.setTotem(i)
		}
		this.mode = "form"
	}

	createForm() {
		this.formTotem = this.formBuilder.group({
			id: [this.totem.id ? this.totem.id : undefined],
			nome: [this.totem.nome ? this.totem.nome : null, Validators.required],
			prefixo: [this.totem.prefixo ? this.totem.prefixo : null, Validators.maxLength(3)],
			paineis: []
		})
	}

	setTotem(i: number) {
		this.totem = this.totems[i]
		this.totemService.getTotemPaineis(this.totem.id!).subscribe(
			(resp) => {
				this.totemPaineis = resp
				this.totem.paineis = []
				resp.forEach((element: { painelid: number; }) => {
					this.totem.paineis?.push(element.painelid)
				});
				this.setForm()
			}
		)
		this.loadTotemPaineis(this.totem.id!)
	}

	deleteTotem(i: number) {
		if (this.totem) {
			this.showSpinner = true
			this.totemService.deleteTotem(i)
			setTimeout(() => {
				this.cleanForm()
				this.loadTotems()
				this.showSpinner = false
			}, 1000);
		}
	}

	cleanForm() {
		this.tempPainelTotem = []
		this.totem = {}
		this.setForm()
		this.mode = "all"
	}

	setForm() {
		if(this.formTotem){
			this.formTotem.controls['id'].setValue(this.totem.id ? this.totem.id : null)
			this.formTotem.controls['nome'].setValue(this.totem.nome ? this.totem.nome : null)
			this.formTotem.controls['prefixo'].setValue(this.totem.prefixo ? this.totem.prefixo : null)
		}
	}

	submitForm() {
		if (this.formTotem.valid) {
			if (this.tempPainelTotem.length === 0 && !this.formTotem.value.id) {
				this.showPainelWarning = true;
				this.tabGroupIndex = 1
				return
			}
			
			if (this.tempPainelTotem.length > 1 && !this.formTotem.value.id) {
				this.showMultiplePainelWarning = true;
			}
			
			this.showSpinner = true
			if (this.formTotem.value.id) {
				this.totemService.updateTotem(this.formTotem.value)
			} else {
				if (this.tempPainelTotem.length > 0) {
					this.formTotem.controls['paineis'].setValue(this.tempPainelTotem)
				}
				this.totemService.insertTotem(this.formTotem.value)
			}
			setTimeout(() => {
				this.tempPainelTotem = []
				this.cleanForm()
				this.totems = []
				this.totemPaineis = []
				this.loadTotems()
				this.showSpinner = false
			}, 1500);
		} else {
			this.tabGroupIndex = 0
			// alert("Dados obrigatórios não preenchidos")
		}
	}

	newTotemPainelForm(i?: number) {
		this.createTotemPainelForm(i)
		this.totemPainelMode = "form"
	}

	createTotemPainelForm(i: number | undefined) {
		if (i !== undefined) {
			this.totemPainel = this.totemPaineis[i]
		}
		this.formTotemPainel = this.formBuilder.group({
			id: [this.totemPainel.id ? this.totemPainel.id : undefined],
			painelid: [this.totemPainel.painelid ? this.totemPainel.painelid : null, Validators.required],
			totemid: [this.totemPainel.totemid ? this.totemPainel.totemid : this.totem.id]
		})
	}

	deleteTotemPainel(i: number) {
		this.showSpinner = true
		if (this.formTotem.value.id !== null) {
			let id = this.totemPaineis[i].id
			this.totemService.deleteTotemPainel(id!)
			setTimeout(() => {
				this.totemPaineis = []
				this.loadTotemPaineis(this.totem.id!)
			}, 1000);
		} else {
			this.totemPaineis = []
			this.tempPainelTotem.splice(i, 1)
			setTimeout(() => {
				this.totemPaineis = this.tempPainelTotem
				
				// Update warning after deletion
				if (this.tempPainelTotem.length === 0) {
					this.showPainelWarning = true
					this.showMultiplePainelWarning = false
				} else if (this.tempPainelTotem.length === 1) {
					this.showPainelWarning = false
					this.showMultiplePainelWarning = false
				} else {
					this.showPainelWarning = false
					this.showMultiplePainelWarning = true
				}
			}, 100);
		}
		setTimeout(() => {
			this.showSpinner = false
		}, 1000);
	}

	submitTotemPainelForm() {
		this.showSpinner = true
		if (this.formTotemPainel.valid) {
			if (this.formTotemPainel.value.totemid && this.formTotemPainel.value.id) {
				this.totemService.updateTotemPainel(this.formTotemPainel.value)
			} else if (this.formTotemPainel.value.totemid) {
				this.totemService.insertTotemPainel(this.formTotemPainel.value)
			}
			else if (this.totem && this.totem.id) {
				this.formTotemPainel.controls['totemid'].setValue(this.totem.id)
				this.totemService.insertTotemPainel(this.formTotemPainel.value)
			} else {
				this.tempPainelTotem.push(this.formTotemPainel.value)
				this.showPainelWarning = false
				
				// Show warning if multiple panels are added
				if (this.tempPainelTotem.length > 1) {
					this.showMultiplePainelWarning = true
				} else {
					this.showMultiplePainelWarning = false
				}
			}
			setTimeout(() => {
				this.totemPainelMode = "all"
				this.totemPainel = {}
				if (this.totem && this.totem.id) {
					this.totemPaineis = []
					this.loadTotemPaineis(this.formTotemPainel.value.totemid)
				} else {
					this.totemPaineis = []
					this.totemPaineis = this.tempPainelTotem
				}
			}, 1000);

		} else {
			alert("Dados obrigatórios não preenchidos.")
		}
		setTimeout(() => {
			this.showSpinner = false
		}, 1000);
	}

	cleanTotemPainelForm() {
		this.totemPainel = {}
		this.totemPainelMode = "all"
	}

	getPainelName(painelid : number){
		return this.paineis.find((e: any) =>
			e.id === painelid)
	}

}
